import { FC } from 'react';
import classNames from 'classnames';
import { Header } from './Header';
import { TopIssues } from './TopIssues';
import { Sections } from './Sections';
import { SharePreview } from './SharePreview';

interface Props {
  isPreviewVisible: boolean;
}

export const CommunityContentPreview: FC<Props> = ({ isPreviewVisible }) => {
  return (
    <div
      className={classNames('content-preview', {
        'show-preview': isPreviewVisible,
        'display-none': !isPreviewVisible,
      })}
    >
      <div className="site-view">
        <img src={require('assets/img/Header.png')} alt="site-preview" className="header-preview" />
        <Header />
        <TopIssues />
        <SharePreview />
        <Sections />
        <img src={require('assets/img/Footer.png')} alt="site-preview" className="header-preview" />
      </div>
    </div>
  );
};
